import { useState, useEffect } from 'react';
import { ResponsiveTestSelection } from '.';
import { responsiveTestsMap } from '../../helpers/data';
import { ResponsiveLogmarContainer } from './Logmar';
import { ResponsiveRandomEContainer } from './RandomE';
import { ResponsiveOptimaChartContainer } from './OptimaChart';
import { ResponsiveContrastSensitivityContainer } from './ContrastSensitivity';
import { ResponsiveRefractionContainer } from './Refraction';
import { ResponsiveRefractionTwoContainer } from './RefractionTwo';

import { ResponsiveKaysOptotypesContainer, MultipleContainer } from './KaysOptotypes';
import { useReceiveMessage } from '../../context/messageContext';

const ResponsiveTestContainer = ({ patientResponse, visualFieldUpdate, isTestInProgress, setActiveTab }) => {
  const [step, setStep] = useState('selectTest');
  const receivedMessage = useReceiveMessage();
  const acuityTestComponents = {
    ResponsiveLogmarContainer,
    ResponsiveRandomEContainer,
    ResponsiveOptimaChartContainer,
    ResponsiveContrastSensitivityContainer,
    ResponsiveRefractionContainer,
    ResponsiveKaysOptotypesContainer,
    MultipleContainer,
    ResponsiveRefractionTwoContainer,
  };

  let TestComponent = acuityTestComponents['ResponsiveLogmarContainer'];

  useEffect(() => {
    if (receivedMessage?.type === 'testNavigationReset') {
      setStep('selectTest');
    }
  }, [receivedMessage]);

  const renderTestComponent = (testKey) => {
    if (testKey in responsiveTestsMap) {
      TestComponent = acuityTestComponents[responsiveTestsMap[step]['reactComponent']];
      return (
        <TestComponent
          logmarType={`${responsiveTestsMap[step]['logmarType']}`}
          setActiveTab={setActiveTab}
          setTestStep={setStep}
          backStep={setStep}
          patientResponse={patientResponse}
          visualFieldUpdate={visualFieldUpdate}
          isTestInProgress={isTestInProgress}
        />
      );
    } else {
      return <ResponsiveTestSelection setActiveTab={setActiveTab} setStep={setStep} />;
    }
  };
  return renderTestComponent(step);
};

export default ResponsiveTestContainer;
